export default __webpack_public_path__ + "static/media/7.e7d90284.png";